"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSlide = selectSlide;
exports.selectCurrentSlideData = selectCurrentSlideData;
exports.selectSettingSlideInProcess = selectSettingSlideInProcess;

var _constants = require("../constants");

function selectModule(state) {
  return state[_constants.SLIDE_MODULE_NAME];
}

function selectSlideState(state) {
  return selectModule(state).slide;
}

function selectSlide(state) {
  return selectSlideState(state).data;
}

function selectSettingSlideInProcess(state) {
  return selectSlideState(state).inProcess;
}

function selectCurrentSlideData(activePresentationBlock) {
  if (activePresentationBlock.slideList) {
    return activePresentationBlock.slideList;
  }

  return [];
}